module.exports = __webpack_public_path__ + "img/logo.d5bbd9a4.png";